module.exports = __webpack_public_path__ + "img/ruzhu.be085a22.png";